import type { Events } from './events';

interface AnalyticsUser {
  anonymousId: () => string;
}

declare global {
  interface Window {
    analytics: {
      track: (...args: unknown[]) => Promise<void>;
      instance: { user: () => AnalyticsUser } | null;
    };
  }
}

const logEvent = <E extends keyof Events>(event: E, params: Events[E]) => {
  if (!window.analytics?.track) {
    console.error(
      'could not find global window.analytics.track, event logging is skipped',
    );
    console.log(event, params);
    return;
  }
  void window.analytics.track(`vo_demo_${event}`, params);
};

export { logEvent };
